import {WebsiteSidebarSubMenu} from "./website-sidebar-sub-menu.model";
import {WebsiteSidebarSubMenuBuilder} from "./website-sidebar-sub-menu.builder";
import {IWebsiteSidebarSubMenuData, WEBSITE_SIDEBAR_SUB_MENUS_DATA} from "./website-sidebar-sub-menus-data";
import {WebsiteSidebarSimpleItemDirector} from "../website-sidebar-simple-item/website-sidebar-simple-item.director";

export type WebsiteSidebarSubMenuType =
  'hostingLive' | 'hostingLiveStagingEnabled' | 'hostingDev' | 'hostingParentSubFolder' | 'hostingParentSubDomain'
  | 'hostingChildSubFolder' | 'hostingChildSubDomain' | 'booster' | 'boosterOnly' | 'boosterDisconnected'
  | 'boosterDisabledDev' | 'boosterDisabled' | 'boosterDev' | 'ecommerceActive' | 'products' | 'advanced';

export class WebsiteSidebarSubMenuDirector {
  static construct(type: WebsiteSidebarSubMenuType): WebsiteSidebarSubMenu {
    if (!WEBSITE_SIDEBAR_SUB_MENUS_DATA[type]) {
      throw new Error(`cannot construct "Sidebar SubMenu" of type ${type}`);
    }
    const data: IWebsiteSidebarSubMenuData = WEBSITE_SIDEBAR_SUB_MENUS_DATA[type];
    const product: WebsiteSidebarSubMenuBuilder = new WebsiteSidebarSubMenuBuilder(data.name, data.label, data.type);
    if (data.img) {
      product.setImg(data.img);
    }
    if (data.icon) {
      product.setIcon(data.icon);
    }
    if (data.subMenu) {
      const subMenu = data.subMenu.map(item => WebsiteSidebarSimpleItemDirector.construct(item));
      product.setSubMenu(subMenu);
    }
    if (data.pageIds) {
      product.setPageIds(data.pageIds);
    }
    if (data.disabled) {
      product.setDisabled(data.disabled);
    }
    if (data.advanced) {
      product.setAdvanced(data.advanced);
    }
    return product.build();
  }
}
